import { Button, Result } from "antd";
import { useNavigate } from "react-router-dom";

const ErrorPage = ({ text, navigationPath, buttonText }) => {
  const navigate = useNavigate();
  return (
    <Result
      status="500"
      title="500"
      subTitle={text}
      extra={
        <Button type="primary" onClick={() => navigate(navigationPath)}>
          {buttonText}
        </Button>
      }
    />
  );
};

export default ErrorPage;
